export const REPORTING_PERIOD = [
    { label: 'Весь срок', value: 'wholePeriod' },
    // { label: 'Месячный', value: 'monthly' },
    // { label: 'Годовой', value: 'yearly' },
    // { label: 'За период', value: 'period' },
];

export const ENTRY_PERIOD = [
    { label: 'Первый месяц года', value: 'yearFirstMonth' },
    { label: 'Декабрь предыдущего года', value: 'previousYearDecember' },
    // { label: 'Соответствующий месяц прошлого года', value: 'lastYearCorrespondingMonth' },
    // { label: 'Базовый месяц', value: 'baseMonth' },
];

export const INDICATORS_LIST = [
    { id: 0, label: 'Qнефть, т', checked: false, isChart: false, isTable: false },
    { id: 1, label: 'qнефть, т/сут', checked: false, isChart: false, isTable: false },
    { id: 2, label: 'Qжидкость, т', checked: false, isChart: false, isTable: false },
    { id: 3, label: 'qжидкость, т/сут', checked: false, isChart: false, isTable: false },
    { id: 4, label: 'обводненность, %', checked: false, isChart: false, isTable: false },
    { id: 5, label: 'дней эксплуатации', checked: false, isChart: false, isTable: false },
    { id: 6, label: 'К эксплуатации', checked: false, isChart: false, isTable: false },
    { id: 7, label: 'Нд, м', checked: false, isChart: false, isTable: false },
    { id: 8, label: 'Ннасос, м', checked: false, isChart: false, isTable: false },
    { id: 9, label: 'Рзатр, МПа', checked: false, isChart: false, isTable: false },
    { id: 10, label: 'Потери нефти, всего', checked: false, isChart: false, isTable: false },
    { id: 11, label: 'Суточные потери, всего', checked: false, isChart: false, isTable: false },
    { id: 12, label: 'Потери по % воды (мес)', checked: false, isChart: false, isTable: false },
    { id: 13, label: 'Потери по % воды (сут)', checked: false, isChart: false, isTable: false },
    { id: 14, label: 'Потери по износу ГНО (мес)', checked: false, isChart: false, isTable: false },
    { id: 15, label: 'Потери по износу ГНО (сут)', checked: false, isChart: false, isTable: false },
    { id: 16, label: 'Потери по сниж. давления (мес)', checked: false, isChart: false, isTable: false },
    { id: 17, label: 'Потери по сниж. давления (сут)', checked: false, isChart: false, isTable: false },
    { id: 18, label: 'n сумм (за период)', checked: false, isChart: false, isTable: false },
    { id: 19, label: 'n сумм (за месяц)', checked: false, isChart: false, isTable: false },
    { id: 20, label: 'n обвод (за период)', checked: false, isChart: false, isTable: false },
    { id: 21, label: 'n обвод (за месяц)', checked: false, isChart: false, isTable: false },
    { id: 22, label: 'n ГНО (за период)', checked: false, isChart: false, isTable: false },
    { id: 23, label: 'n ГНО (за месяц)', checked: false, isChart: false, isTable: false },
    { id: 24, label: 'n Рпл. (за период)', checked: false, isChart: false, isTable: false },
    { id: 25, label: 'n Рпл. (за месяц)', checked: false, isChart: false, isTable: false },
    { id: 26, label: 'n сумм (за месяц)', checked: false, isChart: false, isTable: false },
    { id: 27, label: 'n обвод (за период)', checked: false, isChart: false, isTable: false },
    { id: 28, label: 'n обвод (за месяц)', checked: false, isChart: false, isTable: false },
    { id: 29, label: 'n ГНО (за период)', checked: false, isChart: false, isTable: false },
    { id: 30, label: 'n ГНО (за месяц)', checked: false, isChart: false, isTable: false },
    { id: 31, label: 'n Рпл. (за период)', checked: false, isChart: false, isTable: false },
    { id: 32, label: 'n Рпл. (за месяц)', checked: false, isChart: false, isTable: false },
    { id: 33, label: 'n сумм (за месяц)', checked: false, isChart: false, isTable: false },
    { id: 34, label: 'n обвод (за период)', checked: false, isChart: false, isTable: false },
    { id: 35, label: 'n обвод (за месяц)', checked: false, isChart: false, isTable: false },
    { id: 36, label: 'n ГНО (за период)', checked: false, isChart: false, isTable: false },
    { id: 37, label: 'n ГНО (за месяц)', checked: false, isChart: false, isTable: false },
    { id: 38, label: 'n Рпл. (за период)', checked: false, isChart: false, isTable: false },
    { id: 39, label: 'n Рпл. (за месяц)', checked: false, isChart: false, isTable: false },
    { id: 40, label: 'n сумм (за месяц)', checked: false, isChart: false, isTable: false },
    { id: 41, label: 'n обвод (за период)', checked: false, isChart: false, isTable: false },
    { id: 42, label: 'n обвод (за месяц)', checked: false, isChart: false, isTable: false },
    { id: 43, label: 'n ГНО (за период)', checked: false, isChart: false, isTable: false },
    { id: 44, label: 'n ГНО (за месяц)', checked: false, isChart: false, isTable: false },
    { id: 45, label: 'n Рпл. (за период)', checked: false, isChart: false, isTable: false },
    { id: 46, label: 'n Рпл. (за месяц)', checked: false, isChart: false, isTable: false },
];

export const CURRENT_TAB = {
    CALCULATION_SETTINGS: 'Настройки расчета',
    CALCULATION_RESULTS: 'Результаты расчета',
};

export const WIDGET_TYPE = {
    CHARTS: 'Графики',
    APPROXIMATION: 'Аппроксимация',
};

export const TABLE_CELLS_FIELDS = {
    DATE_1: 'date-1',
    DATE_1_DEBIT_OIL: 'date-1-debitOil',
    DATE_1_DEBIT_LIQUID: 'date-1-debitLiquid',
    DATE_2: 'date-2',
    DATE_2_DEBIT_OIL: 'date-2-debitOil',
    DATE_2_DEBIT_LIQUID: 'date-2-debitLiquid',
    MINUS_DEBIT_OIL: 'minus-debitOil',
    PLUS_DEBIT_OIL: 'plus-debitOil',
    PLUS_MINUS_WEIGHT_DEBIT_OIL: 'plusMinusWeight-debitOil',
    PLUS_MINUS_PERCENT_Q_OIL_PERCENT: 'plusMinusPercent-qOilPercent',
    GROWTH_LOSS_OIL_TOTAL_LOSSES: 'growthLossOil-totalLosses',
    GROWTH_LOSS_OIL_WATERCUT_PERCENT: 'growthLossOil-P-obv', // % потерь/прирост (+/-) дебит нефти
    GROWTH_OIL_WATERCUT: 'growthOil-P-obv',
    GROWTH_OIL_RPL: 'growthOil-P-rpl',
    GROWTH_OIL_GNO: 'growthOil-P-gno',
    LOSS_OIL_WATERCUT: 'lossOil-P-obv',
    LOSS_OIL_RPL: 'lossOil-P-rpl',
    LOSS_OIL_GNO: 'lossOil-P-gno',
    DATE_2_GNO_DESCENT_DEPTH: 'date-2-gnoDescentDepth', // Гл. спуска ГНО, м
    DATE_2_ATM_N_PRIV: 'date-2-atmNpriv', // Нприв. пласт. атм
    DATE_1_ATM_N_PRIV: 'date-1-atmNpriv', // Нприв. пласт. атм
    AVG_MOTHLY_LOSSES_TOTAL_LOSSES: 'AvgMonthlyLosses-totalLosses', // Среднемесячная доля потерь - Потери общие
    AVG_MOTHLY_LOSSES_WATERCUT: 'AvgMonthlyLosses-P-obv', // Среднемесячная доля потерь - П обв
    AVG_MOTHLY_LOSSES_RPL: 'AvgMonthlyLosses-P-rpl', // Среднемесячная доля потерь - П РПЛ
    AVG_MOTHLY_LOSSES_GNO: 'AvgMonthlyLosses-P-gno', // Среднемесячная доля потерь - П ГНО
    NUMBER_DAYS_PER_PERIOD: 'numberDaysPerPeriod',
    EXPLOIT_MOD: 'exploitMod',
    NO_DATA: 'Нет данных',
};
